/**
 * Words the assistant typed into a form, waiting for the form to open.
 *
 * "Add an event for Savta's birthday last Tuesday" should not end with somebody
 * staring at an empty box. So the assistant opens the right form with the title
 * already in it — and then stops. It cannot press Save, on purpose: what reaches
 * the family's records is always something a person looked at and agreed to.
 * A half-filled form they can correct is help; a saved record they never saw is
 * a thing that happened to them.
 *
 * A one-shot handover rather than shared state: the assistant leaves the values
 * here, the form takes them as it opens, and they are gone. A form that opens
 * again a minute later is empty, which is what anybody would expect.
 */

export type PrefillForm = 'add.event' | 'add.milestone' | 'add.photo' | 'report';

export interface PrefillValues {
  title?: string;
  notes?: string;
  caption?: string;
  detail?: string;
}

let pending: { form: PrefillForm; values: PrefillValues } | null = null;

export function setPrefill(form: PrefillForm, values: PrefillValues): void {
  pending = { form, values };
}

/** Take the waiting values for this form, if any. Reading them clears them. */
export function takePrefill(form: PrefillForm | null): PrefillValues | null {
  if (!form || pending?.form !== form) return null;
  const { values } = pending;
  pending = null;
  return values;
}

export function clearPrefill(): void {
  pending = null;
}
